export default "__VITE_ASSET__wPizl72U__"